import axios from 'axios';
import { Message } from 'element-ui/lib';
import store from '@/store';
import qs from 'qs';
import router from '@/router';

export const restApi = ({ url, method = 'get', data = null, params = null, loading = true, headType = null, uploadSts = null }) => {
  // const URL = process.env.VUE_APP_URL;
  const URL = '';
  if (loading) {
    store.dispatch('loading/loading', 1);
  }
  // if (process.env.NODE_ENV === 'production' && url.indexOf('aliyuncs.com') < 0) {
  // url = 'https://fengtai.saienchuanmei.com' + url
  url = `${URL}${url}`;
  // url = `https://testprivacy.lawtrust.cn${url}`;
  // }
  let headers = {
    // token: getToken(),
    token: localStorage.getItem('token') ? JSON.parse(localStorage.getItem('token')).data : ''
  };
  if (headType) {
    let _type = headType.toLocaleLowerCase();
    switch (_type) {
      case 'formdata':
        headers = {
          // token: getToken(),
          'Content-Type': 'multipart/form-data'
        };
        // eslint-disable-next-line no-param-reassign
        data = formData(data);
        break;
      case 'form':
        headers = {
          // token: getToken(),
          'Content-Type': 'application/x-www-form-urlencoded'
        };
        // eslint-disable-next-line no-param-reassign
        data = `request=${data.request}`;
        break;
      case 'upload':
        headers = {
          // token: getToken(),
          'Content-Type': 'image/jpg',
          'x-oss-meta-author': 'longfengshan'
        };
        break;
      case 'mp4':
        headers = {
          // token: getToken(),
          'Content-Type': 'audio/mp4',
          'x-oss-meta-author': 'longfengshan'
        };
        break;
      case 'uploadsts':
        headers = { tempToken: uploadSts };
        break;
      default: break;
    }
  }
  return axios({
    headers,
    method,
    url,
    data,
    params,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false });
    }
  }).then((response) => {
    if (loading) {
      setTimeout(() => store.dispatch('loading/loading', -1), 30);
    }
    if (response.data === null && response.config.responseType === 'json' && response.request.responseText !== null) {
      response.data = JSON.parse(response.request.responseText);
    }
    if (response.data.code === 1000) {
      store.dispatch('app/resetVuex');
      Message.error('用户身份验证失效，请重新验证');
      setTimeout(() => {
        if (isMobile) {
          router.push('/verification');
        } else {
          router.push('/privacy-attestation');
          store.commit("app/CHANGE_STATUS", true);
        }
      }, 3000);
      return;
    }
    return response.data;
  }).catch(async e => {
    if (loading) {
      setTimeout(() => store.dispatch('loading/loading', -1), 30);
    }
    console.info(e.response);
    if (e.response) {
      const status = e.response.status;
      switch (status) {
        case 401:
          console.dir(e);
          router.push('/login');
          break;
        case 400:
          if (e.response.data.resultMsg) {
            Message.error(e.response.data.resultMsg);
          } else {
            Message.error(JSON.stringify(e.response));
          }
          console.dir(e);
          break;
        case 403:
          console.dir(e);
          Message.error(JSON.stringify(e.response));
          break;
        case 404:
          console.dir(e);
          Message.error('接口404了');
          break;
        default:
          if (e.response && e.response.data && e.response.data.resultMsg) {
            return Message.error(e.response.data.resultMsg.toString());
          }
          console.dir(e);
          Message.error(e.toString());
      }
    } else {
      console.dir(e);
      Message.error(e.toString());
    }
    return null;
  });
};
// const getToken = () => {
//   const token = localStorage.token;
//   if (token) {
//     return token;
//   }
//   return null;
// };
const formData = (arg) => {
  let _obj = new FormData();
  for (let x in arg) {
    if (arg[x] instanceof Array) {
      arg[x].forEach(item => {
        return _obj.append(x, item);
      });
    } else {
      _obj.append(x, arg[x]);
    }
  }
  return _obj;
};
export default restApi;
